import {FiltersGroup} from '@/types/models/creator-crm/filter';
import {
  PlatformFilterId,
  FiltersGroupId,
  CreatorDetailsFilterId,
  FilterIds,
} from '@/types/models/creator-crm/filterId';
import {
  ageFilter,
  audienceAgeFilter,
  categoryFilter,
  platformMetricsFilter,
  genderFilter,
  locationFilter,
  platformFilter,
  vettingDecisionFilter,
  campaignHistoryFilter,
  weightedGenderFilter,
  audienceLocationFilter,
} from '@/stores/creator-crm/filterInstance';

const creatorDetailsFiltersGroup: FiltersGroup<CreatorDetailsFilterId> = {
  isCollapsable: true,
  localeLabelKey: 'Creator Details',
  filters: {
    category: categoryFilter,
    gender: genderFilter,
    age: ageFilter,
    location: locationFilter,
    vettingDecision: vettingDecisionFilter,
    campaignHistory: campaignHistoryFilter,
  },
};

const platformsFiltersGroup: FiltersGroup<PlatformFilterId> = {
  isCollapsable: true,
  localeLabelKey: 'Platforms',
  filters: {
    platform: platformFilter,
    platformMetrics: platformMetricsFilter,
    gender: weightedGenderFilter,
    age: audienceAgeFilter,
    location: audienceLocationFilter,
  },
};

const initialFiltersGroups: Record<FiltersGroupId, FiltersGroup<FilterIds>> = {
  creatorDetails: creatorDetailsFiltersGroup,
  platforms: platformsFiltersGroup,
};

export default initialFiltersGroups;
